<template>
  <div class="create-cert-overlay" @click.self="$emit('close')">
    <div class="create-cert-modal credit-purchase-modal">

      <!-- Zavření -->
      <button class="credit-purchase-modal__close" @click="$emit('close')">×</button>

      <!-- Záhlaví: ikona + nadpis — centrováno -->
      <div class="credit-purchase-modal__header">
        <img :src="iconFlash" alt="" class="credit-purchase-modal__icon">
        <h2 class="credit-purchase-modal__title">{{ $t('credits.getMoreCredits') }}</h2>
      </div>

      <!-- Tělo: možnosti nákupu -->
      <div class="credit-purchase-modal__body">
        <form :action="formAction" method="GET" @submit="$emit('processing')">
          <input type="hidden" name="_token" :value="csrfToken">
          <input type="hidden" name="price_id" :value="selectedPriceId">
          <input type="hidden" name="currency" :value="currency">

          <div class="credit-purchase-modal__options">
            <label
              v-for="(option, key) in options"
              :key="key"
              class="credit-purchase-modal__option"
              :class="{ 'credit-purchase-modal__option--selected': selectedAmount === key }"
            >
              <!-- Checkbox -->
              <input
                type="radio"
                class="credit-purchase-modal__radio"
                v-model="selectedAmount"
                :value="key"
              >

              <!-- Počet kreditů + best value badge -->
              <span class="credit-purchase-modal__credits">
                {{ key }} {{ key == 1 ? $t('credits.credit') : $t('credits.creditsUnit') }}
              </span>
              <span v-if="key == maxOption" class="credit-purchase-modal__best-value">
                {{ $t('credits.bestValue') }}
              </span>

              <!-- Cena -->
              <span class="credit-purchase-modal__price ms-auto">
                {{ formatPrice(option.price, currency) }}
              </span>
            </label>
          </div>

          <!-- Footer: celkem + tlačítko -->
          <div class="credit-purchase-modal__footer">
            <div class="credit-purchase-modal__total">
              <span class="credit-purchase-modal__total-label">{{ $t('credits.total') }}</span>
              <span class="credit-purchase-modal__total-price">
                <span class="credit-purchase-modal__total-amount">{{ totalAmount }}</span>
                <span class="credit-purchase-modal__total-currency">{{ currency }}</span>
              </span>
            </div>

            <button
              class="btn btn-primary credit-purchase-modal__submit"
              type="submit"
              :disabled="!selectedAmount || isProcessing"
            >
              {{ isProcessing ? $t('credits.isProcessing') : $t('credits.continueToCheckout') }}
              <i class="bi bi-chevron-right ms-2"></i>
            </button>
          </div>
        </form>
      </div>

    </div>
  </div>
</template>

<script>
import http from '@/http';
import iconFlash from '/public/img/new-design/icons/flash.svg';

export default {
  emits: ['close', 'processing'],

  data() {
    return {
      options: {},
      selectedAmount: null,
      currency: 'CZK',
      isProcessing: false,
      csrfToken: document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
      iconFlash,
    };
  },

  computed: {
    formAction() {
      return '/pay';
    },

    selectedPriceId() {
      if (!this.selectedAmount || !this.options[this.selectedAmount]) return null;
      return this.options[this.selectedAmount].price_id;
    },

    maxOption() {
      const keys = Object.keys(this.options).map(Number);
      return keys.length ? Math.max(...keys) : null;
    },

    totalAmount() {
      if (!this.selectedAmount || !this.options[this.selectedAmount]) return '—';
      return new Intl.NumberFormat('cs-CZ', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(this.options[this.selectedAmount].price / 100);
    },
  },

  mounted() {
    // Stejný zdroj jako backend (/api/certs/prices bere měnu z cookie app_locale) – dřív se měna
    // brala z localStorage a mohla nesedět s vrácenými cenami (pak /pay skončil chybou).
    this.currency = this.$i18n.locale === 'cs' ? 'CZK' : 'EUR';
    this.getPrices();
  },

  methods: {
    getPrices() {
      http.get('/certs/prices').then((response) => {
        this.options = response.data ?? {};
      }).catch(() => {});
    },

    formatPrice(amountInCents, currency) {
      return new Intl.NumberFormat('cs-CZ', {
        style: 'currency',
        currency: currency || 'CZK',
        maximumFractionDigits: 2,
      }).format(amountInCents / 100);
    },
  },
};
</script>